import * as XLSX from 'xlsx';

/**
 *  Törzsadat-fájl beolvasása importhoz.
 *
 *  XLS/XLSX/CSV: itt, a böngészőben parse-oljuk (SheetJS) – a szervernek már kész sorok mennek.
 *  DBF: a SheetJS 0.18-as build NEM ismeri fel (üres munkalapot ad vissza), az RLB partnertörzse
 *  viszont pont DBF. Ezért a nyers fájlt küldjük fel base64-ként, és a szerver olvassa – ott a
 *  kódlapot (CP852/CP1250) is ki tudjuk venni a DBF fejlécéből.
 */
export interface BeolvasottTablazat {
  partnerek: any[];      // parse-olt sorok (nem-DBF fájlnál)
  sorok: any[];          // ugyanaz, beszédesebb néven
  dbf: string | null;    // base64 nyers tartalom, ha DBF
  fajlnev: string;
}

// A DBF első bájtja a verzió-jelző; ezekkel indul minden dBase/FoxPro állomány.
const DBF_JELEK = [0x03, 0x83, 0x30, 0x31, 0x32, 0x8b, 0xf5, 0x43, 0x63, 0xcb];

export async function tablazatBeolvas(file: File): Promise<BeolvasottTablazat> {
  const puffer = await file.arrayBuffer();
  const bajtok = new Uint8Array(puffer);
  const dbfE = /\.dbf$/i.test(file.name) || (bajtok.length > 32 && DBF_JELEK.includes(bajtok[0]));

  if (dbfE) {
    let binaris = '';
    const darab = 0x8000;                                  // nagy fájlnál a spread túlcsordulna
    for (let i = 0; i < bajtok.length; i += darab) {
      binaris += String.fromCharCode.apply(null, Array.from(bajtok.subarray(i, i + darab)) as any);
    }
    return { partnerek: [], sorok: [], dbf: btoa(binaris), fajlnev: file.name };
  }

  const wb = XLSX.read(bajtok, { type: 'array', codepage: 1250 });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const sorok = ws ? XLSX.utils.sheet_to_json(ws, { raw: false, defval: null }) : [];
  return { partnerek: sorok, sorok, dbf: null, fajlnev: file.name };
}
